import './pending.scss'
import { useStore } from '../../store'

export default function Pending() {
  const { state } = useStore()

  return state.pendingData.open ? (
    <div className="pending">
      <div className="__onemt__loader-box">
        <div className="__onemt__loader"></div>
      </div>
    </div>
  ) : null
}
